module.exports = {
  socketServer: 'ws://staging.reinventexchange.com/ws',
  googleAnalyticsTrackingId: 'G-8FWBKMS9VH',
  photosUrl: 'https://photos.reinventexchange.com',
  sentryTrackingDsn: 'https://26d2e3954d9cdf9f1e6b2125ee6bc8ae@o4505992811511808.ingest.us.sentry.io/4505992815116288',
  environment: "production"
}